import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pa-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-h5 mb-5" }, "Perfil do usuário", -1)
const _hoisted_3 = { class: "d-flex align-center" }
const _hoisted_4 = { class: "mb-3 text-h6" }
const _hoisted_5 = { class: "d-flex text-grey" }
const _hoisted_6 = { class: "ml-4" }

import logout from '@/app/shared/application/services/logout';
import rightDrawerState from '@/app/shared/infrastructure/state/right-drawer';
import userRepository from '@/app/shared/infrastructure/persistence/user-repository';


export default /*#__PURE__*/_defineComponent({
  __name: 'RightDrawer',
  setup(__props) {

const state = rightDrawerState();
const user = userRepository().get();

function handleLogout() {
    logout().handle();
}

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createBlock(_component_v_navigation_drawer, {
    location: "right",
    width: "375",
    temporary: "",
    modelValue: _unref(state).open,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).open) = $event))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_avatar, { size: "100" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_img, {
                src: _unref(user).image,
                alt: _unref(user).name
              }, null, 8, ["src", "alt"])
            ]),
            _: 1
          }),
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(user).name), 1),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_v_icon, { color: "primary" }, {
                default: _withCtx(() => [
                  _createTextVNode("mdi:mdi-email")
                ]),
                _: 1
              }),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(user).email), 1)
            ])
          ])
        ]),
        _createVNode(_component_v_divider, { class: "my-8" }),
        _createVNode(_component_v_btn, {
          onClick: handleLogout,
          "prepend-icon": "mdi:mdi-logout",
          color: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Sair ")
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})